var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.35,
    height: 9.533,
    viewBox: "0 0 18.35 9.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-397.5 -178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16,.8,15.2,0A10.2,10.2,0,0,1,.8,0L0,.8A11.279,11.279,0,0,0,8,4.1,11.279,11.279,0,0,0,16,.8Z",
    transform: "translate(398.675 178)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M.567,0A.584.584,0,0,0,0,.567V3.4a.584.584,0,0,0,.567.567A.584.584,0,0,0,1.133,3.4V.567A.584.584,0,0,0,.567,0Z",
    transform: "translate(406.108 183.566)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M1.1.4A.549.549,0,0,0,.4.029a.549.549,0,0,0-.367.7L.9,3.429a.571.571,0,0,0,.533.4A.3.3,0,0,0,1.6,3.8a.549.549,0,0,0,.367-.7Z",
    transform: "translate(409.746 182.804)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M2.975,2.175l-2-2a.545.545,0,0,0-.8,0,.545.545,0,0,0,0,.8l2,2a.615.615,0,0,0,.4.167.615.615,0,0,0,.4-.167A.545.545,0,0,0,2.975,2.175Z",
    transform: "translate(412.7 181.559)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M1.6.029A.537.537,0,0,0,.9.4L.029,3.1A.537.537,0,0,0,.4,3.8a.3.3,0,0,0,.167.033.571.571,0,0,0,.533-.4l.867-2.7A.549.549,0,0,0,1.6.029Z",
    transform: "translate(401.646 182.837)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M2.175.175l-2,2a.545.545,0,0,0,0,.8.615.615,0,0,0,.4.167.615.615,0,0,0,.4-.167l2-2a.545.545,0,0,0,0-.8A.544.544,0,0,0,2.175.175Z",
    transform: "translate(397.5 181.592)",
    fill: "#cfcfcf"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show-password.fe0c082fac556caa1f6b958eeaa6341d.svg";
export { ForwardRef as ReactComponent };